<app-header-brazil></app-header-brazil>
<section class="mt-5 mb-5">
    <h2 class="mr-3 mb-0">Top 10 Cidades - {{title}}</h2>

    <div class="state-cards">
        <div class="state-card box mt-4 mb-4 mr-5" *ngFor="let city of cities; let i = index">
            <div class="d-flex flex-row">
                <h3 class="mb-3 mr-2">{{i+1}}) {{city.nome}}</h3>
                <img src="https://devarthurribeiro.github.io/covid19-brazil-api/static/flags/{{city.estado}}.png" alt="Bandeira do estado de {{city.estado}}" width="45" height="30">
            </div>
            <div class="d-flex flex-row" *ngIf="option == 'casos'">
                <p class="mr-2">Casos confirmados: <span>{{numberWithCommas(city.casos)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mr-2">Casos recuperados: <span>{{numberWithCommas(city.recuperados)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mb-3"> Óbitos confirmados: <span>{{numberWithCommas(city.mortes)}}</span></p>
            </div>
            <div class="d-flex flex-row" *ngIf="option == 'obitos'">
                <p class="mr-2">Casos confirmados: <span>{{numberWithCommas(city.casos)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mr-2">Casos recuperados: <span>{{numberWithCommas(city.recuperados)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mb-3"> Óbitos confirmados: <span>{{numberWithCommas(city.mortes)}}</span></p>
            </div>
            <div class="d-flex flex-row" *ngIf="option == 'gastosMax' || option == 'gastosMin'">
                <p class="mr-2">Dinheiro gasto: <span>R$ {{numberWithCommas(city.dinheiro)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mr-2">Casos confirmados: <span>{{numberWithCommas(city.casos)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mr-2">Casos recuperados: <span>{{numberWithCommas(city.recuperados)}}</span></p>
                <p class="mr-2">|</p>
                <p class="mb-3"> Óbitos confirmados: <span>{{numberWithCommas(city.mortes)}}</span></p>
            </div>
        </div>
    </div>
</section>
